import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { User } from './../models/user';
import { Organization, OrganizationMember } from './../models/organization';
import { StorageService } from './storage.service'
import { OrganizationService } from './organization.service'
import { Subject, firstValueFrom } from 'rxjs';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { UserService } from './user.service'
import { blobToBase64 } from '../utils'
import { Transaction, NativePurchases, PURCHASE_TYPE } from '@capgo/native-purchases';
import { SecureStorageService } from './secure-storage.service';
import { NetworkService } from './network.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn: boolean = false;
  username: string | null = null;
  redirectUrl: string | null = null;
  pendingRedirectUrl: string | null = null;
  notifications = []

  public _statusChange$ = new Subject<boolean>();
  public loginStatus$ = this._statusChange$.asObservable();

  public _logout$ = new Subject<boolean>();
  public logout$ = this._logout$.asObservable();

  public _notificationsUpdate$ = new Subject<boolean>();
  public notificationsUpdate$ = this._notificationsUpdate$.asObservable();


  constructor(
    private http: HttpClient,
    public storageService: StorageService,
    private router: Router,
    private navCtrl: NavController,
    public alertController: AlertController,
    private userService: UserService,
    private organizationService: OrganizationService,
    private secureStorageService: SecureStorageService,
    public networkService: NetworkService,
  ) { }

  reloadRunning = false
  reloadUser(token: string, username: string, redirect_url: string | null = null) {
    this.username = username;

    if (this.reloadRunning) {
      // Si un redirect est fourni (login social), le mémoriser pour l'appliquer quand le reload en cours se termine
      if (redirect_url) this.pendingRedirectUrl = redirect_url;
      return null;
    }
    this.reloadRunning = true;

    const headers = new HttpHeaders({
      'Authorization': "Token " + token
    });
    return this.http.get<User>(environment.API_URL + 'userProfile/ws_private/User/', { headers: headers })
      .pipe(
        tap(user => {
          this.reloadRunning = false;
          if (user['success'] == false) {
            this.logoutDeleteLocalData();
            this._statusChange$.next(false);
          } else {
            if (this.userService.user == null) {
              this.userService.user = new User();
            }
            this.userService.user.id = user['id'];
            this.userService.user.addrCountry = user['addrCountry'];
            this.userService.user.addrCountry = user['addrCountry'];
            this.userService.user.addrPostalcode = user['addrPostalcode'];
            this.userService.user.addrStreet = user['addrStreet'];
            this.userService.user.avatar = user['avatar'];
            this.userService.user.birthday = user['birthday'];
            this.userService.user.email = user['email'];
            this.userService.user.firstName = user['firstName'];
            this.userService.user.languageCode = user['languageCode'];
            this.userService.user.gender = user['gender'];
            this.userService.user.lastName = user['lastName'];
            this.userService.user.isSuperuser = user['isSuperuser'];
            this.userService.user.isStaff = user['isStaff'];
            this.userService.user.phoneNumber = user['phoneNumber'];
            this.userService.user.success = user['success'];
            this.userService.user.identifier = user['identifier']
            this.userService.user.publicPageIsActive = user['publicPageIsActive']
            this.userService.user.postDefaultVisiblity = user['postDefaultVisiblity'];
            this.userService.user.isVisibleOnSearch = user['isVisibleOnSearch'];
            this.userService.user.weightUnit = user['weightUnit'];
            this.userService.user.date_joined = user['date_joined']
            this.userService.user.token = token;
            this.isLoggedIn = true;
            this.userService.user.lastUpdateFromServer = new Date();

            if (user['organization'] && user['organizationMember']) {
              if (!this.userService.user.organizationMember)
                this.userService.user.organizationMember = new OrganizationMember()
              this.userService.user.organizationMember.id = user['organizationMember']['id']
              this.userService.user.organizationMember.userId = user['organizationMember']['userId']
              this.userService.user.organizationMember.firstName = user['organizationMember']['firstName']
              this.userService.user.organizationMember.lastName = user['organizationMember']['lastName']
              this.userService.user.organizationMember.isRoleAdmin = user['organizationMember']['isRoleAdmin']
              this.userService.user.organizationMember.isRoleWriteMembers = user['organizationMember']['isRoleWriteMembers']
              this.userService.user.organizationMember.isRoleReadMembers = user['organizationMember']['isRoleReadMembers']
              this.userService.user.organizationMember.isRoleWriteAnimals = user['organizationMember']['isRoleWriteAnimals']
              this.userService.user.organizationMember.isRoleReadAnimals = user['organizationMember']['isRoleReadAnimals']
              this.userService.user.organizationMember.isRoleWriteAgenda = user['organizationMember']['isRoleWriteAgenda']
              this.userService.user.organizationMember.isRoleReadAgenda = user['organizationMember']['isRoleReadAgenda']
              this.userService.user.organizationMember.isRoleWritePlan = user['organizationMember']['isRoleWritePlan']
              this.userService.user.organizationMember.isRoleReadPlan = user['organizationMember']['isRoleReadPlan']

              this.userService.user.organizationMember.isRoleWritePharmacy = user['organizationMember']['isRoleWritePharmacy']
              this.userService.user.organizationMember.isRoleReadPharmacy = user['organizationMember']['isRoleReadPharmacy']
              this.userService.user.organizationMember.isRoleWriteShare = user['organizationMember']['isRoleWriteShare']
              this.userService.user.organizationMember.isRoleReadShare = user['organizationMember']['isRoleReadShare']
              this.userService.user.organizationMember.isRoleWriteFosterFamily = user['organizationMember']['isRoleWriteFosterFamily']
              this.userService.user.organizationMember.isRoleReadFosterFamily = user['organizationMember']['isRoleReadFosterFamily']
              this.userService.user.organizationMember.isRoleWriteVet = user['organizationMember']['isRoleWriteVet']
              this.userService.user.organizationMember.isRoleReadVet = user['organizationMember']['isRoleReadVet']
              this.userService.user.organizationMember.isRoleWriteOrganization = user['organizationMember']['isRoleWriteOrganization']
              this.userService.user.organizationMember.isBenevoleWalker = user['organizationMember']['isBenevoleWalker']
              this.userService.user.organizationMember.isRoleWriteCompta = user['organizationMember']['isRoleWriteCompta']
              this.userService.user.organizationMember.isRoleReadCompta = user['organizationMember']['isRoleReadCompta']


              if (!this.userService.user.organization) {
                this.userService.user.organization = this.organizationService.organizations.find(a => a.id == user?.organization?.id) ?? null
                if (!this.userService.user.organization) {
                  this.userService.user.organization = new Organization()
                  this.organizationService.organizations.push(this.userService.user.organization)
                }
              }
              this.userService.user.organization.id = user['organization']['id']
              this.userService.user.organization.name = user['organization']['name']
              this.userService.user.organization.types = user['organization']['types']
              this.userService.user.organization.avatar = user['organization']['avatar']
              this.userService.user.organization.userId = user['organization']['userId']
              this.userService.user.organization.subscription = user['organization']['subscription']
              this.userService.user.organization.postDefaultVisiblity = user['organization']['postDefaultVisiblity']
              this.userService.user.organization.postDefaultVisiblityLitter = user['organization']['postDefaultVisiblityLitter']
              this.userService.user.organization.affix = user['organization']['affix']
              this.userService.user.organization.isActivePublicPage = user['organization']['isActivePublicPage']
              this.userService.user.organization.weightUnit = user['organization']['weightUnit']
              this.userService.user.organization.acaced = user['organization']['acaced'] ?? null
              this.userService.user.organization.email = user['organization']['email'] ?? ''
              this.userService.user.organization.phoneNumber = user['organization']['phoneNumber'] ?? ''
              this.userService.user.organization.addrStreet = user['organization']['addrStreet'] ?? ''
              this.userService.user.organization.addrPostalCode = user['organization']['addrPostalCode'] ?? ''
              this.userService.user.organization.addrCity = user['organization']['addrCity'] ?? ''
              this.userService.user.organization.identifier = user['organization']['identifier'] ?? ''

              if (user['organization']['avatarBase64'] != null) {
                this.userService.user.organization.avatarBase64 = user['organization']['avatarBase64'];
              } else if (this.userService.user.organization.avatar != null) {
                this.userService.user.organization.avatarBase64 = null;
                this.http.get(this.userService.user.organization.avatar, { responseType: 'blob' as 'blob' }).subscribe(data => {
                  blobToBase64(data).then((res: any) => {
                    if (this.userService.user?.organization)
                      this.userService.user.organization.avatarBase64 = res;
                  });
                });
              }
            }

            this.secureStorageService.set('auth_token', token);
            const userToSave = { ...this.userService.user } as any;
            delete userToSave.token;
            this.storageService.set('user', userToSave);

            setTimeout(() => {
              this._statusChange$.next(true);
              const urlToNavigate = redirect_url ?? this.pendingRedirectUrl;
              this.pendingRedirectUrl = null;
              if (urlToNavigate)
                this.router.navigateByUrl(urlToNavigate);
            }, 50);
          }
        })
      )
  }

  logout() {
    const headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders()
    });

    this.logoutDeleteLocalData();

    return this.http.post(environment.API_URL + 'userProfile/ws_private/Logout/', {}, { headers: headers })
      .pipe(
        tap(data => {
          this.userService.user = null;
          this._statusChange$.next(false);
          this._logout$.next(false);
          return data;
        })
      ).subscribe();
  }

  async logoutDeleteLocalData() {
    this.storageService.remove("user");
    await this.secureStorageService.remove('auth_token');
    this.isLoggedIn = false;
    if (this.userService.user != null)
      this.userService.user.token = null;
    this.userService.user = null;
    this.username = null;
    this.notifications = []
  }

  getIsLoggedIn() {
    return this.getToken();
  }

  async getToken(forceUpdate = false) {

    // Attendre que le storage soit prêt
    const storageReady = await this.storageService.waitForReady();
    if (!storageReady) {
      this.isLoggedIn = false;
      this._statusChange$.next(false);
      return Promise.resolve(null);
    }

    if (!forceUpdate && this.userService.user != null && this.userService.user.token != null && this.userService.user.lastUpdateFromServer != null && new Date().getTime() - this.userService.user.lastUpdateFromServer.getTime() < 5 * 60 * 1000) {
      this.isLoggedIn = true;
      this._statusChange$.next(true);
      return new Promise(resolve => {
        resolve(this.userService.user?.token || null);
      });
    } else {
      // 1. Essayer de récupérer le token depuis le stockage sécurisé
      let secureToken = await this.secureStorageService.get('auth_token');

      return this.storageService.get('user').then(
        async data => {
          if (data != null) {
            this.userService.user = data;
            this.userService.user = Object.assign(new User(), this.userService.user);
            this.userService.user.organizationMember = Object.assign(new OrganizationMember(), this.userService.user.organizationMember);
            this.userService.user.organization = Object.assign(new Organization(), this.userService.user.organization);

            // 2. Migration : si on n'a pas de token sécurisé mais qu'on en a un vieux dans l'objet "user"
            if (!secureToken && this.userService.user.token) {
              secureToken = this.userService.user.token;
              await this.secureStorageService.set('auth_token', secureToken);

              // Nettoyage de l'ancien stockage
              const userToSave = { ...this.userService.user } as any;
              delete userToSave.token;
              this.storageService.set('user', userToSave);
            }

            if (this.userService.user) {
              this.userService.user.token = secureToken; // Réassignation du token sécurisé
              this.username = this.userService.user.email;
              this.isLoggedIn = true; // Set to true as soon as we have a token in storage
              this._statusChange$.next(true);
            }
          } else {
            this.logoutDeleteLocalData();
          }

          if (this.userService.user?.token != null && this.username != null) {
            if (this.networkService.isOnline()) {
              const reloadObs = this.reloadUser(this.userService.user?.token, this.username, null);
              if (reloadObs) {
                try {
                  await firstValueFrom(reloadObs);
                } catch (e) {
                  // En cas d'erreur réseau, on considère qu'on est toujours connecté si on a un token
                  this.isLoggedIn = true;
                  this._statusChange$.next(true);
                }
              }
            } else {
              // Hors connexion, on fait confiance au stockage local s'il contient un utilisateur
              this.isLoggedIn = true;
              this._statusChange$.next(true);
            }
            return this.userService.user?.token || null;
          } else {
            this.isLoggedIn = false;
            this._statusChange$.next(false);
            return null;
          }
        },
        async error => {
          if (this.userService.user != null)
            this.userService.user.token = null;
          this.userService.user = null;
          this.isLoggedIn = false;
          this._statusChange$.next(false);
          return null;
        }
      );
    }
  }

  setNotifications(notifications: []) {
    this.notifications = notifications;
    this._notificationsUpdate$.next(true);
  }
}
